export default from './WindowScroller'
export WindowScroller from './WindowScroller'
export { IS_SCROLLING_TIMEOUT } from './utils/onScroll'



/** WEBPACK FOOTER **
 ** ./source/WindowScroller/index.js
 **/